








































import Vue from 'vue';
import { namespace } from 'vuex-class';
import { Component, Watch, Prop } from 'vue-property-decorator';

@Component
export default class ModalMobile extends Vue {
  @Prop({ default: true }) private readonly persistent?: boolean;
  @Prop({ default: false }) private readonly value?: boolean;
  @Prop({ default: false }) private readonly showGoBack: boolean;
  @Prop({ default: true }) private readonly showClose: boolean;
  @Prop({ default: true }) private readonly hasFooter: boolean;
  @Prop({ default: true }) private readonly sticky: boolean;
  @Prop() private readonly goBackAction?: Function;

  private backAction() {
    if (this.goBackAction) {
      this.goBackAction();
    } else {
      this.defaultClose();
    }
  }

  get hasHeaderSlot() {
    return !!this.$slots['header'];
  }

  get hasFooterSlot() {
    return !!this.$slots['footer'];
  }

  private defaultClose() {
    this.$emit('close');
    this.$emit('input', false);
  }

  private toggle() {
    const dialog = this.$refs.dialog as any;
    if (!dialog.disabled) dialog.isActive = !dialog.isActive;
  }
}
